import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import { offerQueryKeys } from 'lib/queryKeys';

import { getStoreOffersList } from 'services/store';

import TimelineNavigator from './TimelineNavigator';

import { SORT_VALUES } from 'constants/sort';

const OffersList = dynamic(() => import('./OffersList'));
const StoreCouponsList = dynamic(() => import('./CouponsList'));

const ITEMS_LIMIT = 24;

const TimelineList = ({
  gaEventCategory,
  isExclusivelyCoupon = false,
  isOfferPage,
  serverCoupons = null,
  serverOffers = null,
  storeId,
  storeName,
  storeSlug,
}) => (
  <>
    {!isExclusivelyCoupon && (
      <TimelineNavigator className="mb-5 lg:mb-8" storeSlug={storeSlug} />
    )}
    {isOfferPage ? (
      <OffersList
        gaEventCategory={gaEventCategory}
        initialOffers={serverOffers}
        queryFn={({ after }, opts) =>
          getStoreOffersList(
            {
              after,
              limit: ITEMS_LIMIT,
              sort: SORT_VALUES.LATEST,
              storeSlug,
            },
            opts
          )
        }
        queryKey={offerQueryKeys.listByStore({
          storeId,
          offersSort: SORT_VALUES.LATEST,
        })}
      />
    ) : (
      <StoreCouponsList
        gaEventCategory={gaEventCategory}
        serverCoupons={serverCoupons}
        storeId={storeId}
        storeName={storeName}
        storeSlug={storeSlug}
      />
    )}
  </>
);

TimelineList.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  isExclusivelyCoupon: PropTypes.bool,
  isOfferPage: PropTypes.bool.isRequired,
  serverCoupons: PropTypes.shape({
    after: PropTypes.string,
    coupons: PropTypes.arrayOf(
      PropTypes.shape({
        couponId: PropTypes.number.isRequired,
        couponDiscountValue: PropTypes.string.isRequired,
        couponDiscountShort: PropTypes.string.isRequired,
        couponDiscount: PropTypes.string.isRequired,
        couponDiscountOn: PropTypes.string.isRequired,
        couponStatusName: PropTypes.string.isRequired,
        couponInstructions: PropTypes.string.isRequired,
        couponVerified: PropTypes.bool,
        storeImage: PropTypes.string,
        storeName: PropTypes.string.isRequired,
        storeDomain: PropTypes.string.isRequired,
        storeSlug: PropTypes.string.isRequired,
        couponTag: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
        couponPublished: PropTypes.string.isRequired,
        couponTitle: PropTypes.string.isRequired,
        couponCode: PropTypes.string.isRequired,
        couponUrl: PropTypes.string.isRequired,
        userName: PropTypes.string,
      })
    ).isRequired,
  }),
  serverOffers: PropTypes.shape({
    after: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sort: PropTypes.string,
    before: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    offers: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        offerComments: PropTypes.number.isRequired,
        offerId: PropTypes.number.isRequired,
        offerIsHighlight: PropTypes.bool.isRequired,
        ratings: PropTypes.shape().isRequired,
        offerOldPrice: PropTypes.number,
        offerPhoto: PropTypes.string.isRequired,
        offerPrice: PropTypes.number.isRequired,
        offerPriceType: PropTypes.string.isRequired,
        offerPublished: PropTypes.string.isRequired,
        offerSlug: PropTypes.string.isRequired,
        offerStatusName: PropTypes.string.isRequired,
        offerUserVisibility: PropTypes.string.isRequired,
        offerTags: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string.isRequired,
            type: PropTypes.string.isRequired,
          })
        ),
        offerTitle: PropTypes.string.isRequired,
        storeDomain: PropTypes.string.isRequired,
      }).isRequired
    ).isRequired,
  }),
  storeId: PropTypes.number.isRequired,
  storeName: PropTypes.string.isRequired,
  storeSlug: PropTypes.string.isRequired,
};

export default TimelineList;
